<!--
 * @Description: 明细
 * @Author: chenwenxin
 * @Date: 2022-3-01 10:19:35
 -->
<template>
  <div class="main-wrap waybill">
    <div class="waybill-top">
      <el-button type="primary" @click="exportOpen" :loading="exportLoading" icon="iconfont icondaochu" class="h40 exportOpen" plain>{{ $lang('导出') }}</el-button>
      <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
    </div>
    <div class="waybill-bottom">
      <div class="waybill-nav">
        <div class="waybill-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ item.waybillStatusName }}<span class="waybill-nav-item-count">{{ item.count }}</span>
        </div>
      </div>
      <JmsTable
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-del="rowDel"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @current-change="currentChange"
      >
      </JmsTable>
    </div>
    <!-- 导出订单弹框组件 -->
    <export-componet
      ref="exportComponet"
      :cityOptions="portDelOptions"
      :exportVisible="exportVisible"
      :idsLength="selection.length"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet>
    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
  </div>
</template>
<script>
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import { enterPortDel, enterDetailExport } from '@/api/module/customer'
import exportComponet from '@components/base/BaseExport.vue'
import { portDelOptions, RESPONSE_SUCCESS } from '@constants'
import { mapGetters } from 'vuex'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'

export default {
  name: 'DetailList',
  mixins: [mixin],
  components: {
    JmsTable,
    ExportDownloadDialog,
    exportComponet,
  },
  data () {
    return {
      pickerOptions: {
      },
      COM_HTTP: {
        reqList: enterPortDel,
        reqExcel: enterDetailExport,
      },
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      isShowFirst: true,
      menuItems: [], // 导航栏
      activeIndex: '0',
      selection: [],
      exportVisible: false, // 导出弹框显示
      excelParams: {},
      exportStatus: 'all',
      exportType: 2, // 1：订单； 2：运单
      exportLoading: false,
      exportData: {},
      portDelOptions: [],
      tabActive: 0,
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'in_detail_harbor', // 进港
      waybillLogStatus: ''
    }
  },
  computed: {
    countryCode () {
      return this.$store.state.base.user.countryCode || ''
    },
    ...mapGetters(['user']),
    listOpt () {
      return {
        border: true,
        selection: false,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        column: [
          {
            label: this.$lang('派件时间'),
            prop: 'deliverTime',
          },
          {
            label: this.$lang('运单号'),
            prop: 'billcode',
          },
          {
            label: this.$lang('目的地省份'),
            prop: 'providerDesc',
          },
          {
            label: this.$lang('目的地城市'),
            prop: 'cityDesc',
          },
          {
            label: this.$lang('计费重量'),
            prop: 'packageInsideChargeWeight',
          },
          {
            label: this.$lang('是否COD'),
            prop: 'codNeed',
            formatter: (row) => {
              return row.codNeed === '1' ? '是' : '否'
            },
          },
          {
            label: this.$lang('代收货款'),
            prop: 'codMoney',
          },
          {
            label: this.$lang('签收时间'),
            prop: 'signTime',
          },
          {
            label: this.$lang('是否问题件'),
            prop: 'ifQuestion',
          },
          {
            label: this.$lang('问题件原因'),
            prop: 'prblemReason',
          },
          {
            label: this.$lang('问题件登记时间'),
            prop: 'questionFirstName',
          },
          {
            label: this.$lang('问题件描述'),
            prop: 'problemDesc',
          },
          {
            label: this.$lang('是否退回件'),
            prop: 'ifReturn',
          },
          {
            label: this.$lang('退回件登记时间'),
            prop: 'returnTime',
          },
          {
            label: this.$lang('退回机构'),
            prop: 'returnInstitution',
          },
          {
            label: this.$lang('总体签收时长'),
            prop: 'signLong',
          },
        ],
      }
    },
  },
  created() {
    const pam = this.$route.query
    if (pam) {
      console.log(12121212, pam)
      pam.startTime = pam.startTime_sum
      pam.endTime = pam.endTime_sum
      this.searchParam = Object.assign({}, pam)
      console.log('return', this.searchParam)
      this.searchFun(1)
    }
  },
  methods: {
    // 选择分页条数
    sizeChange (val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.selection = []
    },
    // 获取下单渠道下拉数据，请求列表数据
    async getOrderOrigin (key) {
      try {
        // const { code, data } = await queryCustomerOrderSource()
        const { code, data } = {}
        if (code === RESPONSE_SUCCESS) {
          if (data.length) {
            this.orderSourceCodeList = this.orderSourceCodeList.concat(data)
          } else {
            this.orderSourceCodeList = []
          }
          await this.countByStatus()
          if (key) {
            this.handleSelect(key)
          } else {
            this.searchFun()
          }
        } else {
          this.orderSourceCodeList = []
        }
      } catch (error) {
        this.orderSourceCodeList = []
      }
    },
    // 跳转页码
    currentChange (val) {
      this.page.current = val
      this.searchFun()
      this.selection = []
    },
    // 查看方法
    async viewFun (row) {
      if (this.isRowDetailUrl) {
        const { data, code, msg } = await this.COM_HTTP.reqDetail({ waybillNo: row.waybillNo }) // 根据运单号
        if (code === RESPONSE_SUCCESS) {
          console.log('查看调用成功')
          // 回显数据
          const newRow = this.handleData(data)
          this.rowData = Object.assign({}, { ...newRow })
        } else {
          this.$message.error(msg)
        }
      } else {
        // 回显数据
        this.rowData = this.handleData(row)
      }
    },
    // 删除方法
    async deleteFun (item) {
      const res = await this.COM_HTTP.reqDel(item)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.afterDelSuccess()
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * 去详情
     */
    getExpressTracking (waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    // 导出-获取参数
    getParamForOutExcel () {
      const sort = []
      const columnNames = []
      let ids = []
      // 获取选中行的数量
      const len = (this.selection && this.selection.length) || 0
      // 选中行ids处理（未选中不穿此参数）
      if (len) ids = this.selection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { ids, sort, columnNames, orderStatusCode: this.exportStatus }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      return params
    },
    getParams() {
      var params = Object.assign({}, this.searchParam)
      params.current = this.page.current
      params.size = this.page.size
      console.log('000000000', params)
      return params
    },
    // 打开导出弹框
    async exportOpen () {
      if (this.selection.length <= 0) {
        this.exportLoading = true
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.tableList
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.portDelOptions = [...portDelOptions]
      // this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose (val) {
      this.exportVisible = val
    },
    // 导出数据
    async exportFn (status, data, dataParams) {
      this.exportVisible = status
      this.columnList = data
      this.excelParams = dataParams
      // 调用导出方法
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportWaybill()
    },
    async asyExportWaybill () {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请前往下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 获取运单状态列表
    getOrderOriginCode (orderSourceCode) {
      let codes = []
      if (!orderSourceCode) {
        const dataCodes = this.orderSourceCodeList.map(item => item.groupOrderSourceCode)
        codes = dataCodes
      } else {
        codes = [orderSourceCode]
      }
      return codes
    },
    closeDetails (val) {
      this.viewDialogVisible = val.viewDialogVisible
    },
    imgDialogChange (val) {
      if (val) this.viewDialogVisible = false
      if (!val) this.viewDialogVisible = true
    },
    // 表格复选框选择回调
    selectionChange (val) {
      this.selection = val
    },
    // 删除后的回调
    afterDelSuccess () {
      this.searchFun(1)
      setTimeout(this.countByStatus, 500)
    },
    changeTab (index) {
      this.tabActive = index
      this.handleSelect(index)
    },
  },
}
</script>
<style lang="scss" scoped>
// @import '@assets/iconfont/iconfont.css
.el-form-item {
  margin-bottom: 0;
}
.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}
.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}
.waybill {
  .waybill-top {
    //   padding :24px;
    padding: 16px 24px;
    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
    .waybill-topLeft {
      margin-top: 10px;
    }
  }
  .waybill-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }
  .waybill-nav {
    //   margin: 9px 0;
    .waybill-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 16px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;
      //   width: 124px;
      &:first-of-type {
        margin-left: 0px;
      }
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
    .waybill-nav-item-count {
      display: inline-block;
      width: 28px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>

<style lang="scss">
.waybill .waybill-top .el-input__inner {
  margin-bottom: 10px;
}
</style>
